import React, { useEffect } from 'react';
import { useState } from 'react';
import Exclamation from '../../../../assets/icons/Exclamation';
import {
  Container,
  Header,
  Footer,
  Label,
  Reminder,
  ReText,
  DivIcon,
  Subtitle,
} from './styles';

import Button from '../../../../components/general/Button';
import Close from '../../../../assets/icons/Close';
import Modal from '../../../../components/general/Modal';
import { useSelector } from 'react-redux';
import { getFlowById } from '../../../../state/flows/selectors';

//isOpen -> Controlador se o modal está aberto ou não
//onClose -> Função executada ao cancelar/fechar/clicar fora do modal
//onConfirm -> Função executada ao confirmar no modal
//selector -> Local onde o modal sera renderizado(root -> Toda a tela)
//className -> nodrag = modal não pode ser movido

const SwitchVersion = ({
  title = '',
  loadflow = () => null,
  isOpen,
  onClose,
  selector,
  className,
  item = null,
  setCritical,
}) => {
  //Create Flow create version
  const flowsState = useSelector((state) => state.flows);
  async function clearCriticalState() {
    setCritical(false);
  }

  const handleClick = () => {
    const switchFlow = getFlowById({ flowsState, flowId: item._id });
    loadflow(switchFlow);
    clearCriticalState().then(() => onClose());
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Header>
          <Label>Trocar versão</Label>
          <Reminder>
            <Exclamation style={{ height: '1.3125rem', width: '1.3125rem' }} />
            <ReText>
              Lembrete: ao trocar a versão do fluxo as alterações não salvas
              serão perdidas!
            </ReText>
          </Reminder>
          <Subtitle>
            Deseja trocar para a versão{' '}
            <span style={{ color: '#118052', fontWeight: 'bold' }}>
              {item?.title}
            </span>
            ?
          </Subtitle>
        </Header>
        <Footer>
          <Button
            outline
            content="Cancelar"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={onClose}
          />
          <Button
            content="Confirmar"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={handleClick}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default SwitchVersion;
